import { Injectable, inject } from '@angular/core';
import { IFreightAvailable, IFreightAvailableDetailed } from '@okcargo-apps/shared-domain';
import { BaseQueryRepository } from '../query-repository/query.repository';
import { FindOptions, SearchResult } from '../query-repository/query.model';
import {
  SearchOptionsInput,
  transformToSearchOptions,
  transformToSearchResult,
} from '../query-repository/query.mapper';
import {
  FindMarketFreightForCarrierQueryHandler,
  SearchMarketFreightsForCarriersQueryHandler,
} from '@okcargo/query-processor';
import { mapBaseFreight, transformToIFreightAvailableDetailed } from './freight-available-query.mapper';

@Injectable({
  providedIn: 'root',
})
export class FreightAvailableQueryService {
  private readonly queryRepository = inject(BaseQueryRepository);

  private readonly searchMarketFreightsForCarriersQueryHandler: SearchMarketFreightsForCarriersQueryHandler;
  private readonly findMarketFreightForCarrierQueryHandler: FindMarketFreightForCarrierQueryHandler;

  constructor() {
    const queryRepository = this.queryRepository;

    this.searchMarketFreightsForCarriersQueryHandler = new SearchMarketFreightsForCarriersQueryHandler(queryRepository);
    this.findMarketFreightForCarrierQueryHandler = new FindMarketFreightForCarrierQueryHandler(queryRepository);
  }

  public async searchFreightsAvailable(options: SearchOptionsInput = {}): Promise<SearchResult<IFreightAvailable>> {
    const response = await this.searchMarketFreightsForCarriersQueryHandler.handle(transformToSearchOptions(options));
    return transformToSearchResult(response, mapBaseFreight);
  }

  public async findFreightAvailable(options: FindOptions): Promise<IFreightAvailableDetailed> {
    // FindMarketFreightForCarrierQuery
    const response = await this.findMarketFreightForCarrierQueryHandler.handle(options);

    return transformToIFreightAvailableDetailed(response);
  }
}
